import { useRef } from 'react';
import { ArrowUpRight, Mail, X } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../../../components/ui/dialog';
import SafeImage from '../../../components/SafeImage';
import './support-social.css';

export function SupportSocialIcon({ channel, meta, customIcon }) {
  const assetDirectory = ['facebook', 'instagram', 'whatsapp'].includes(channel)
    ? 'brand-profile' : ['discord', 'tiktok', 'telegram'].includes(channel) ? 'support' : null;
  const src = customIcon || (assetDirectory ? `/assets/${assetDirectory}/${channel}.png` : '');
  const fallback = <span className="support-social-glyph" style={{ background: meta.gradient }}>
    {meta.Glyph ? <meta.Glyph /> : <Mail size={24} />}
  </span>;
  return <span className="support-social-icon" aria-hidden="true">
    {src ? <SafeImage src={src} alt="" width={56} height={56} className={customIcon ? 'support-social-custom-icon' : 'support-social-generated-icon'} retry={0} fallback={fallback} /> : fallback}
  </span>;
}

export default function SupportSocialChannels({ open = true, socials, icons = {}, metadata, onClose, onOpenChannel }) {
  const available = Object.keys(metadata).filter(key => socials[key]);
  const returnFocus = useRef(null);

  return <Dialog open={open} onOpenChange={isOpen => { if (!isOpen) onClose(); }}>
    <DialogContent
      showClose={false}
      className="support-social-dialog"
      overlayClassName="support-social-overlay"
      onOpenAutoFocus={() => { returnFocus.current = document.activeElement; }}
      onCloseAutoFocus={event => { event.preventDefault(); returnFocus.current?.focus?.(); }}
      data-testid="support-picker"
    >
      <header className="support-social-dialog-header">
        <div>
          <DialogTitle className="support-social-title">Social media support</DialogTitle>
          <DialogDescription className="support-social-description">
            Choose a channel to contact your team.
          </DialogDescription>
        </div>
        <button type="button" onClick={onClose} className="support-social-close" aria-label="Close social media support" data-testid="support-picker-close"><X size={20} /></button>
      </header>
      <div className="support-social-channel-list" data-testid="support-picker-list">
        {available.length === 0 && <div className="support-social-empty">
          <p>No social support channels available yet.</p>
          <span>You can still contact your team through live chat.</span>
        </div>}
        {available.map(key => {
          const meta = metadata[key];
          return <button key={key} type="button"
            onClick={() => onOpenChannel(key)}
            aria-label={`Open ${meta.label}`}
            className="support-social-row"
            data-testid={`support-picker-${key}`}>
            <SupportSocialIcon channel={key} meta={meta} customIcon={icons[key]} />
            <span className="support-social-copy">
              <span className="support-social-name">{meta.label}</span>
              <span className="support-social-address">{String(socials[key]).replace(/^https?:\/\//, '').replace(/^mailto:/, '')}</span>
            </span>
            <span className="support-social-open">Open <ArrowUpRight size={15} aria-hidden="true" /></span>
          </button>;
        })}
      </div>
    </DialogContent>
  </Dialog>;
}
